import { render } from "./Beschreibung.vue?vue&type=template&id=cdadd9ca&scoped=true"
import script from "./Beschreibung.vue?vue&type=script&lang=js"
export * from "./Beschreibung.vue?vue&type=script&lang=js"

import "./Beschreibung.vue?vue&type=style&index=0&id=cdadd9ca&lang=stylus&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdadd9ca"]])

export default __exports__